<template>
    <div class="flex">

        <div
            class="inline-flex -mx-1 cursor-pointer"
            @mouseleave="unhover"
        >
            <button
                v-for="index in 5"
                :key="index"
                @click="select"
            >
                <StarFilledIcon
                    :class="{ 'text-orange-light' : index <= selected }"
                    class="h-4 w-4 text-grey-lighter transition-fast content-box px-1"
                    @mouseover="hover(index)"
                />
            </button>
        </div>

    </div>
</template>

<script>
import StarFilledIcon from '~/static/fonts/LineIcons/star-filled.svg';

export default {

    components: {
        StarFilledIcon,
    },

    data() {
        return {
            hovered: 5,
            selected: 5,
        };
    },

    methods: {
        hover(index) {
            this.hovered = index;
        },
        unhover() {
            this.hovered = this.selected;
        },
        select() {
            this.selected = this.hovered;
            this.$emit('input', this.selected);
        },
    },

};
</script>

<style lang="scss" scoped>
.content-box {
    box-sizing: content-box;
}
</style>
